<template>
  <div
    class="bg-gray px-4 py-1 d-block d-flex justify-content-start rounded"
    style="box-shadow: black 2px 3px 12px; padding: 8px !important;"
  >
    <div v-if="news.image">
      <img :src="news.image" alt="news" width="105" height="105">
    </div>
    <div style="padding: 0px 4px 0px 12px">
      <h5>{{ news.title }}</h5>
      <div>{{ news.text }}</div>
    </div>
  </div>
</template>

<script>
export default {

  name: 'News',

  props: {
    news: Object
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/shared/News.vue